module.exports = ".error-status{\r\n    font-size: 24px;\r\n    text-align: center;\r\n}\r\n\r\n.error-message{\r\n    text-align: center;\r\n    font-weight: bold;\r\n}\r\n\r\n.error{\r\n    padding-top: 20%\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/unauthorized/unauthorized.component.css
// module id = ./src/app/shared/components/unauthorized/unauthorized.component.css
// module chunks = main